import { render, staticRenderFns } from "./veStuYyprojectShow.vue?vue&type=template&id=c24c9c4c&scoped=true"
import script from "./veStuYyprojectShow.vue?vue&type=script&lang=js"
export * from "./veStuYyprojectShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24c9c4c",
  null
  
)

export default component.exports